var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentDrawerType==='modal')?_c('div',{staticClass:"vt-drawer-root"},[_c('aside',{key:"drawer",ref:"mdcModalDrawer",staticClass:"mdc-drawer mdc-drawer--modal vt-drawer"},[_vm._t("default")],2),_c('div',{staticClass:"mdc-drawer-scrim"})]):_c('div',{staticClass:"vt-drawer-root"},[_c('aside',{key:"drawer",staticClass:"mdc-drawer vt-drawer",class:{
        'vt-drawer--dismissible':_vm.currentDrawerType === 'dismissible',
        'vt-drawer-open':_vm.drawerOpen_,
        'vt-drawer-animation':_vm.drawerAnimation_,
        'vt-drawer-close':_vm.drawerClose_,
    }},[_vm._t("default")],2),_c('div',{staticClass:"vt-drawer-area",class:{
    'vt-drawer-open':_vm.drawerOpen_,
    'vt-drawer-animation':_vm.drawerAnimation_,
    'vt-drawer-close':_vm.drawerClose_,
  }})])}
var staticRenderFns = []

export { render, staticRenderFns }